
import React from 'react'
import ReactDOM from 'react-dom'
import Alert from './Alert'
import Box from './Box'

/**
 * ToastManager manages toasts.
 */

class ToasterManager {
  constructor() {
    const el = document.createElement('div')
    el.setAttribute('data-toast-container', '')
    document.body.appendChild(el)
    this.el = el
    this.toasts = new Map
    this.ids = 0
  }

  notify(message, type, { closeable = true, duration = 3000, unique = false } = {}) {
    const id = unique ? message : this.ids++
    this.toasts.set(id, { id, type, message, closeable })
    if (duration) {
      setTimeout(_ => this.remove(id), duration)
    }
    this.render()
  }

  success(message, options) {
    this.notify(message, 'info', options)
  }
  
  danger(message, options) {
    this.notify(message, 'error', options)
  }

  remove(id) {
    this.toasts.delete(id)
    this.render()
  }

  render() {
    ReactDOM.render(<Toasts>
      {this.renderToasts()}
    </Toasts>, this.el)
  }

  renderToasts() {
    const toasts = Array.from(this.toasts.values())
    return toasts.map((t, i) => {
      const { id, type, message, closeable } = t
      return <Alert key={id} theme={type} animate="show" onClose={_ => this.remove(id)} closeable={closeable}>
        {message}
      </Alert>
    })
  }
}

/**
 * Toasts component.
 */

function Toasts({ children }) {
  return <Box className="Toasts">
    {children}
  </Box>
}

/**
 * Toast manager.
 */

export default new ToasterManager